import React, {Fragment, useContext, useEffect, useState} from 'react';
import PropTypes from "prop-types";

import ModalContentWrapper from '../ModalContentWrapper';
import '../TwoColumnModal.scss';

import SpinnerDiv from "root/Forms/UI/SpinnerDiv";

import {SaveButton} from "root/Modals/SaveButton";
import {getChildDetails} from "root/DataFunctions/ChildDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";

export const ModalReinstateModes = {
    REINSTATE: 'reinstate',
    COMPLETE: 'complete',
}
const ModalReinstateChild = ({ child_id, onSaveCompleted, onClose, mode, width }) =>
{
    const [ buttonsDisabled, setButtonsDisabled ] = useState ( false ) ;

    const [data, setData] = useState({isLoading: true, data: []});

    useEffect(() =>
    {
        if ( [ ModalReinstateModes.REINSTATE ].includes (mode) )
        {
            getChildDetails( child_id, {}, (response) =>
            {
                const rec = getDataFromResponse( response ) ;

                setData ( { isLoading: false, data:rec }) ;
            })
        }
        else
        {
            setData ( { isLoading: false, data:[] }) ;
        }
    }, []);

    const onSaveComplete = () =>
    {
        onSaveCompleted('saved', child_id);
        onClose();
    }

    const onClickCancel = () =>
    {
        onClose();
        onSaveCompleted('cancel', null);
    }

    const doReinstate = (data, onSaveComplete) =>
    {
        onClose();
        onSaveCompleted('saved', child_id);
    }

    const disableButtons = () =>
    {
        setButtonsDisabled(true);
    }

    const getSaveButtonText = () =>
    {
        const saveButtonText = {
            [ModalReinstateModes.REINSTATE]: 'Reinstate Pupil',
        };

        return saveButtonText[mode];
    }

    const onSubmit = () =>
    {
        disableButtons();

        switch ( mode )
        {
            case ModalReinstateModes.REINSTATE :
                doReinstate(data, onSaveComplete);
                break ;
        }
    }

    const explanatoryPara = () =>
    {
        const name = data.data[0].firstname + ' ' + data.data[0].surname ;

        const saveButtonText = {
            [ModalReinstateModes.REINSTATE]: <div><p>You are about to REINSTATE <strong>{name}</strong>.</p><p>You can then update their details and assign teachers, carers etc</p></div>,
        };

        return saveButtonText[mode];
    }

    const reinstateContent = () =>
    {
        return (
            <Fragment>
                <div className='buy-card'>
                    <div>
                        <span className="glyphicon glyphicon-exclamation-sign" style={{color: 'var(--s360-icon-red', fontSize: '8rem', marginTop: '30px'}}></span>
                    </div>
                    <div className='buy-card-right' style={{ marginBottom: '70px', marginTop: '20px'}}>
                        <div style={{marginBottom: '1rem'}}>{explanatoryPara()}</div>
                        <div>Click the <span className='button-descriptor'>{getSaveButtonText(mode)}</span>&nbsp;button below to return the pupil and enter their details.</div>
                    </div>
                    <button onClick={onClickCancel} className="btn btn-secondary">Cancel<i className="et-arrow-bold-left"/></button>
                    <SaveButton onClick={onSubmit} disabled={buttonsDisabled}>{getSaveButtonText(mode)}</SaveButton>
                </div>
            </Fragment>
        )
    }

    const completeContent = () =>
    {
        return (
            <Fragment>
                <div className='buy-card'>
                    <div>
                        <span className="glyphicon glyphicon-check" style={{color: 'var(--s360-icon-green', fontSize: '8rem', marginTop: '30px'}}></span>
                    </div>
                    <div className='buy-card-right' style={{ marginBottom: '70px', marginTop: '20px'}}>
                        <div>Click the button below to return to the home page</div>
                        <div className="button-row top-margin center">
                            <SaveButton onClick={onSaveComplete} disabled={buttonsDisabled}>OK</SaveButton>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }

    const formContent = () =>
    {
        if (data.isLoading === true)
        {
            return (
                <div style={{width: width}}>
                    <SpinnerDiv/>
                </div>
            )
        }
        else
        {
            return reinstateContent();
        }
    }

    const title = () =>
    {
        const titleText = {
            reinstate: 'Reinstate',
            complete: 'Complete',
        };

        const text = titleText[mode];

        const headerStyle = {marginBottom: '10px'};

        return <h3 style={headerStyle}>{text}</h3>
    }

    return (
        <ModalContentWrapper className="modal-update-attendance" width={'600px'} columns={2}>
            {title()}
            { mode === ModalReinstateModes.REINSTATE && formContent()}
            { mode === ModalReinstateModes.COMPLETE && completeContent()}
        </ModalContentWrapper>
    )
}

export default ModalReinstateChild;

ModalReinstateChild.propTypes = {
    params: PropTypes.object,
    user_id: PropTypes.string,
};